<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-select
            style="width: 216px"
            :allowClear="true"
            v-model="promotion_page"
            placeholder="请选择推广页面"
          >
            <a-select-option
              v-for="item in pageList"
              :value="item.id"
              :key="item.id"
            >
              {{ item.remark }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-range-picker
            :default-value="defaultTime"
            v-model="defaultTime"
            format="YYYY/MM/DD"
          />
        </a-form-item>
        <a-form-item>
          <a-button @click="search">搜索</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="vd-gl-content">
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 客户列表</a-col>
        <a-col class="vd-table-tool">
          <a-button-group class="vd-bar-button">
            <a-button @click="collectionData" icon="export">
              导出数据
            </a-button>
          </a-button-group>
          <!-- <a-divider type="vertical" /> -->
          <!-- <a-icon class="common-icon" type="reload"></a-icon> -->
        </a-col>
      </a-row>
      <a-table
        :data-source="list"
        row-key="id"
        :pagination="pagination"
        :loading="loading"
      >
        <a-table-column title="ID" data-index="id" />
        <a-table-column title="推广员" data-index="m_nickname">
          <span slot-scope="text, record">
            <template v-if="text === ''">
              {{ record.member_name }}
            </template>
            <template v-else>
              {{ record.m_nickname }}
            </template>
          </span>
        </a-table-column>
        <a-table-column title="工号" data-index="m_username">
          <span slot-scope="text, record">
            <template v-if="text === ''">
              {{ record.member_code }}
            </template>
            <template v-else>
              {{ record.m_username }}
            </template>
          </span>
        </a-table-column>
        <a-table-column title="客户手机号" data-index="mobile" />
        <a-table-column title="推广时间" data-index="add_time">
          <span slot-scope="text">
            {{ $FormatUtil.timestamp2date(text) }}
          </span>
        </a-table-column>
        <a-table-column title="操作">
          <template slot-scope="text">
            <a-tag color="blue" @click="pushInfo(text.id)"> 推送到Crm</a-tag>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import {
  export_excel,
  pushDataToCrm,
  patchPushDataToCrm,
  getPromotionPage,
  get_collection,
} from '@/api/program'

export default {
  name: 'client',
  data() {
    return {
      list: [],
      pageList: [],
      active_id: 0,
      defaultTime: [],
      promotion_page: undefined,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      loading: false,
    }
  },
  created() {
    let query = this.$route.query
    this.active_id = parseInt(query.id)

    if (!this.active_id) {
      this.$message.error('错误的活动参数')
    }
    this.getData()
    getPromotionPage({ active_id: this.active_id }).then((res) => {
      if (res['code'] === 1) {
        this.pageList = res['list']
      } else {
        this.$message.warning(res['msg'])
      }
    })
  },
  methods: {
    getData() {
      this.loading = true
      get_collection({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        id: this.active_id,
        pageId: this.promotion_page,
        timeRange: this.defaultTime,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    search() {
      this.list = []
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    collectionData() {
      export_excel({
        id: this.active_id,
        pageId: this.promotion_page,
        timeRange: this.defaultTime,
      }).then((res) => {
        if (res.type === 'application/json') {
          let reader = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.addEventListener('loadend', () => {
            let msg = JSON.parse(reader.result)
            this.$message.error(msg['msg'])
          })
        } else {
          const disposition = res.headers['content-disposition']
          let fileName = disposition.substring(
            disposition.indexOf('filename=') + 9,
            disposition.length
          )
          let link = document.createElement('a')
          link.style.display = 'none'
          let url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel',
            })
          )
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
    pushInfo(collection_id) {
      pushDataToCrm({
        active_id: this.active_id,
        collection_id: collection_id,
      }).then((res) => {
        if (res['code'] === 1) {
          this.$message.success(res['msg'])
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    pushInfoPatch() {
      patchPushDataToCrm({
        active_id: this.active_id,
      }).then((res) => {
        if (res['code'] === 1) {
          this.$message.success(res['msg'])
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
  },
}
</script>

<style scoped></style>
